import React, { useState } from 'react';
import ScriptTag from 'react-script-tag';

import FakeHT from './FakeHT';

const AsyncHeads = () => {
	const [showFakeHT, setShowFakeHT] = useState(true);

	const loadedHandTalk = () => {
		const body = document.querySelector('body');
		const script = document.createElement('script');

		script.innerHTML = `
		var ht = new HT({
			token: '081446dfee25bd636f35f4d5df183ef0',
			avatar: 'MAYA',
		});
	`;
		body.appendChild(script);
	};

	return (
		<>
			{showFakeHT ? (
				<FakeHT
					onClick={() => {
						setShowFakeHT(false);
					}}
					onMouseOver={() => {
						setShowFakeHT(false);
					}}
				/>
			) : (
				<>
					<ScriptTag
						src="https://plugin.handtalk.me/web/latest/handtalk.min.js"
						async
						onLoad={loadedHandTalk}
					></ScriptTag>
				</>
			)}
		</>
	);
};

export default AsyncHeads;
